export const SET_EXAM_ATTEMPT = "set_exam_attempt";
export const SET_QUESTIONS = "set_question";
export const SET_CURRENT_QUESTION = "set_current_question";
export const SET_VISITED = "set_visited";
export const SET_MARK_REVIEW = "set_mark_review"
export const UPDATE_QUESTION = "update_question"